import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f34c696"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-span-2 p-2" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "font-bold text-gray-900 mb-4" }
const _hoisted_4 = { class: "text-3xl" }
const _hoisted_5 = { class: "text-sm text-gray-500 leading-tight mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  name: "plan",
  id: "plan-growth",
  value: "growth",
  class: "absolute h-0 w-0 appearance-none",
  checked: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute top-4 right-4 h-6 w-6 inline-flex items-center justify-center rounded-full bg-green-200" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    class: "h-5 w-5 text-green-600"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
      "clip-rule": "evenodd"
    })
  ])
], -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_swiper, {
      spaceBetween: 3,
      class: "p-2",
      slidesPerView: 3,
      breakpoints: _ctx.breakpoints
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, j) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            key: item.id
          }, {
            default: _withCtx(() => [
              (item.level)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["relative flex flex-col bg-white p-5 rounded-lg shadow-md cursor-pointer", {'locked': j >= 4}]),
                    onClick: ()=> _ctx.goToLyric(item),
                    style: {"min-height":"15vh"}
                  }, [
                    _createElementVNode("span", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(item.level), 1)
                    ]),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.description), 1),
                    _hoisted_6,
                    _createElementVNode("span", {
                      "aria-hidden": "true",
                      class: _normalizeClass(["absolute inset-0 border-2 border-green-500 bg-green-200 bg-opacity-10 rounded-lg", {'hidden': !item.isSelected}])
                    }, _hoisted_8, 2)
                  ], 10, _hoisted_2))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["breakpoints"])
  ]))
}